import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

const ComponentList = ({ components, onSelectComponent,activeComponent,addedComponentList }) => {

    return (
      <ListGroup>
        {components.map(component => (
          <ListGroupItem
            key={component.id} 
            onClick={() => onSelectComponent(component)}
            tag="button"
            action
            active={activeComponent && activeComponent.id === component.id}
          >
            {addedComponentList.some(inspection => inspection.component_id === component.id) && <span className=' ri-checkbox-circle-line'></span>} {component.component_name}
          </ListGroupItem>
        ))}
      </ListGroup>
    );
  };

  export default ComponentList